import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CrewTimecardGridService {
  http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  getBulkEmployeeList(pRCo, pRGroup) {
    let url = "/CrewTimecard/GetBulkEmployeeList?pRCo=" + pRCo + "&pRGroup=" + pRGroup;
    return this.http.get(url).toPromise();
  }

  getCellPossibleValues(rowData) {
    let url = "/Timecard/GetCellPossibleValues";
    return this.http.post("/Timecard/GetCellPossibleValues", rowData).toPromise();
  }

  getColumnsByPRCoGroup(pRCo, pRGroup, isCrewOrStandard) {
    let url = "/CrewTimecard/GetColumnsByPRCoGroup?pRCo=" + pRCo + "&pRGroup=" + pRGroup + "&isCrewOrStandard=" + isCrewOrStandard;
    return this.http.get(url).toPromise();
  }

  getCrews(pRCo, pRGRoup) {
    let url = "/CrewTimecard/GetCrews?PRCo=" + pRCo + "&PRGroup=" + pRGRoup;
    return this.http.get(url).toPromise();
  }

  getCrewTimecardData(pRPCKeyID, crewTemplateID) {
    let url = "/CrewTimecard/Data?payPeriodId=" + pRPCKeyID + "&templateId=" + crewTemplateID
    return this.http.get(url).toPromise();
  }

  getDailyOtherHours(employeeString, pRCo, pRPCKeyID, crewTemplateID) {
    let url = "/Timecard/GetDailyOtherHours?employee=" + employeeString + "&pRCo=" + pRCo + "&pRPCKeyID=" + pRPCKeyID + "&crewTemplateID=" + crewTemplateID;
    return this.http.get(url).toPromise();
  }

  getDefaultsForEmplList(pREHKeyIDString) {
    let url = "/CrewTimecard/GetDefaultsForEmplList?pREHKeyIDString=" + pREHKeyIDString;
    return this.http.get(url).toPromise();
  }

  getEmplLockStatus(hQBCKeyID, crewTemplateID) {
    let url = "/CrewTimecard/GetEmplLockStatus?hQBCKeyID=" + hQBCKeyID + "&crewTemplateID=" + crewTemplateID;
    return this.http.get(url).toPromise();
  }

  getTimecardColumns(employeeId: number, employee: number, pRCo: number, pRGroup: number, filterType: string, isCrewOrStandard: string) {
    let url = "/Timecard/GetTimecardColumns?employeeId=" + employeeId + "&employee=" + employee + "&pRCo=" + pRCo + "&pRGroup=" + pRGroup + "&isCrewOrStandard=" + isCrewOrStandard
    return this.http.get(url).toPromise();
  }

  approveCrewTimecard(crewTemplateID, pRPCKeyID, keyID, submittedOnString, keyIDString = null) {
    let url = "/CrewTimecard/ApproveCrewTimecard";
    let postData: any = {
      crewTemplateID: crewTemplateID,
      pRPCKeyID: pRPCKeyID,
      keyID: keyID,
      submittedOnString: submittedOnString
    }
    if (keyIDString != null)
      postData.keyIDString = keyIDString;
    return this.http.post(url, postData).toPromise();
  }

  deleteTimecardRow(rowId) {
    let url = "/Timecard/DeleteTimecardRow";
    return this.http.post(url, { rowId: rowId }).toPromise();
  }

  saveCrewTimecard(timecardId, rows, crewTemplateID, jCFTKeyID = null) {
    let url = "/CrewTimecard/SaveCrewTimecard";
    let postData: any = {
      timecardId: timecardId,
      rows: rows,
      crewTemplateID: crewTemplateID,
      employee: -1
    };
    if (jCFTKeyID != null)
      postData.jcftKeyID = jCFTKeyID;
    return this.http.post(url, postData).toPromise();
  }
}
